import { FILTER_CONFIG } from '../customDashboards/universalFiltersConfig';

const universalFilter = key => FILTER_CONFIG.find(filter => filter.key === key);

const PLATFORM_FILTER = {
    key: 'platform',
    fieldName: 'platform',
    labelKey: 'STATIC.PLACEHOLDERS.SELECT_PLATFORM',
    mixpanelEventName: 'Dashboards - Platform Filter Changed',
    mixpanelPropertyName: 'platform_names',
    displayName: 'Platform',
};

const ORGANIC_TYPE_FILTER = {
    key: 'organic_type',
    fieldName: 'organic_type',
    labelKey: 'STATIC.PLACEHOLDERS.SELECT_ORGANIC_TYPE',
    mixpanelEventName: 'Dashboards - Organic Type Filter Changed',
    mixpanelPropertyName: 'organic_type_names',
    displayName: 'Organic Type',
};

export const ORGANIC_INSIGHTS_FILTERS = [
    universalFilter('app'),
    PLATFORM_FILTER,
    universalFilter('country_field'),
    ORGANIC_TYPE_FILTER,
];

// Platform value 0 is Web (Platform.WEB in dashboard/platform.py). Defaulted here (not baked
// into every widget query) so users can still switch it once mobile data is added.
export const ORGANIC_INSIGHTS_DEFAULT_FILTERS = {
    platform: [{ value: 0, label: 'Web' }],
};
